"use strict";
var _a;
Object.defineProperty(exports, "__esModule", { value: true });
exports.MediaStatus = exports.Access = exports.FILE_SIZES = exports.COL = exports.Timestamp = void 0;
const transaction_1 = require("./transaction");
/**
 * Timestamp object.
 */
class Timestamp {
    constructor(seconds, nanoseconds) {
        this.seconds = seconds;
        this.nanoseconds = nanoseconds;
        this.toDate = () => {
            const milliseconds = this.toMillis();
            return new Date(milliseconds);
        };
        this.toMillis = () => {
            const seconds = this.seconds + this.nanoseconds / 1e9;
            return Math.floor(seconds * 1000);
        };
    }
}
exports.Timestamp = Timestamp;
_a = Timestamp;
Timestamp.now = () => _a.fromMillis(Date.now());
Timestamp.fromDate = (date) => _a.fromMillis(date.getTime());
Timestamp.fromMillis = (milliseconds) => {
    const seconds = Math.floor(milliseconds / 1000);
    const nanoseconds = Math.floor((milliseconds / 1000 - seconds) * 1e9);
    return new _a(seconds, nanoseconds);
};
var COL;
(function (COL) {
    COL["MEMBER"] = "member";
    COL["AWARD"] = "award";
    COL["COLLECTION"] = "collection";
    COL["NFT"] = "nft";
    COL["SPACE"] = "space";
    COL["PROPOSAL"] = "proposal";
    COL["NOTIFICATION"] = "notification";
    COL["MILESTONE"] = "milestone";
    COL["MILESTONE_RMS"] = "milestone_rms_t2";
    COL["MILESTONE_SMR"] = "milestone_smr";
    COL["TRANSACTION"] = "transaction";
    COL["BADGES"] = "badges";
    COL["AVATARS"] = "avatars";
    COL["TOKEN"] = "token";
    COL["TOKEN_MARKET"] = "token_market";
    COL["TOKEN_PURCHASE"] = "token_purchase";
    COL["TICKER"] = "ticker";
    COL["STAKE"] = "stake";
    COL["STAKE_REWARD"] = "stake_reward";
    COL["NFT_STAKE"] = "nft_stake";
    COL["AIRDROP"] = "airdrop";
    COL["PROJECT"] = "project";
    COL["STAMP"] = "stamp";
    COL["AUCTION"] = "auction";
    COL["MNEMONIC"] = "_mnemonic";
    COL["SYSTEM"] = "_system";
    COL["DB_ROLL_FILES"] = "_db_roll_files";
    COL["SWAP"] = "swap";
})(COL || (exports.COL = COL = {}));
var FILE_SIZES;
(function (FILE_SIZES) {
    FILE_SIZES["small"] = "200X200";
    FILE_SIZES["medium"] = "680X680";
    FILE_SIZES["large"] = "1600X1600";
})(FILE_SIZES || (exports.FILE_SIZES = FILE_SIZES = {}));
/**
 * Access to collections.
 *
 * @category Accesss Cat
 */
var Access;
(function (Access) {
    Access[Access["OPEN"] = 0] = "OPEN";
    Access[Access["MEMBERS_ONLY"] = 1] = "MEMBERS_ONLY";
    Access[Access["GUARDIANS_ONLY"] = 2] = "GUARDIANS_ONLY";
    Access[Access["MEMBERS_WITH_BADGE"] = 3] = "MEMBERS_WITH_BADGE";
    Access[Access["MEMBERS_WITH_NFT_FROM_COLLECTION"] = 4] = "MEMBERS_WITH_NFT_FROM_COLLECTION";
})(Access || (exports.Access = Access = {}));
/**
 * Status of media upload to the IPFS.
 */
var MediaStatus;
(function (MediaStatus) {
    MediaStatus["UPLOADED"] = "uploaded";
    MediaStatus["PENDING_UPLOAD"] = "pending_upload";
    MediaStatus["ERROR"] = "error";
    MediaStatus["PREPARE_IPFS"] = "prepare_ipfs";
})(MediaStatus || (exports.MediaStatus = MediaStatus = {}));
